import {
  ROLE_BILLING_OWNERS,
  ROUTE_INVOICES_LIST,
  ROUTE_PROFFESSIONAL_SERVICES_QUERY,
  ROUTE_RECURRING_QUERY,
} from "../../SharedModule/utils/constants";
import { LeftNavBar } from "../../SharedModule/components/LeftNavBar";
import { LeftNavBarSection } from "../../SharedModule/components/LeftNavBarSection";
import { selectUserRoles } from "../../SharedModule/redux/reducers/auth.reducer";
import { useSelector } from "react-redux";

export const LeftNavBarBilling = () => {
  const { userRolesList } = useSelector(selectUserRoles);

  return (
    <LeftNavBar>
      <LeftNavBarSection
        mainTitle="Manage Billing"
        biIconName="BiMoneyWithdraw"
        requireModuleAccess={true}
        roleRequired={ROLE_BILLING_OWNERS}
        actualUserRoles={userRolesList}
        listOfLinks={[
          {
            text: "Professional Services",
            route: ROUTE_PROFFESSIONAL_SERVICES_QUERY,
            requireModuleAccess: true,
            roleRequired: ROLE_BILLING_OWNERS,
          },
          {
            text: "Recurring Billing",
            route: ROUTE_RECURRING_QUERY,
            requireModuleAccess: true,
            roleRequired: ROLE_BILLING_OWNERS,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Reports"
        biIconName="BiBarChartAlt2"
        requireModuleAccess={false}
        listOfLinks={[
          { text: "Invoices", route: ROUTE_INVOICES_LIST },
          {
            text: "Billing Reports",
            route: "/billing/billingreports.asp",
            asuiteLink: true,
          },
          {
            text: "View Price Levels",
            route: "/billing/billpricelevels.asp",
            asuiteLink: true,
          },
        ]}
      />
      <LeftNavBarSection
        mainTitle="Administration"
        biIconName="BiShieldQuarter"
        requireModuleAccess={false}
        listOfLinks={[
          {
            text: "Administrative Functions",
            route: "/billing/billingmenu.asp",
            asuiteLink: true,
          },
          {
            text: "Edit Recurring Biling Items",
            route: "/billing/AdminBillingRecurring.asp",
            asuiteLink: true,
          },
          {
            text: "Pay Commissions",
            route: "/billing/BillPayCommissionsSelect.asp",
            asuiteLink: true,
          },
        ]}
      />
    </LeftNavBar>
  );
};
